import React from 'react';

export interface SettlementsData {
	subsidiaryName: string;
	transactionAmount: string;
	currency: string;
	fee: string;
	settlementStatus: React.ReactNode;
	action: React.ReactNode;
}

export const ColumnSettlements = [
	{
		Header: 'Business name',
		accessor: 'subsidiaryName',
	},
	{
		Header: 'Amount',
		accessor: 'transactionAmount',
	},

	{
		Header: 'Settlement Fee',
		accessor: 'fee',
	},
	{
		Header: 'Currency',
		accessor: 'currency',
	},
	{
		Header: 'Status',
		accessor: 'settlementStatus',
	},
	{
		Header: 'Action',
		accessor: 'action',
	},
];
